import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const ObjetivoTaller = () => {
  const { promptData, setPromptData} = useActividadesContext();

  const handleObjetivoTaller = (event) => {
    const objetivoTaller = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        objetivo_taller: objetivoTaller 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color:'#336B87' }}>
        Objetivo del taller *
        </Typography>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Describe brevemente el objetivo principal del taller. </FormLabel>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.objetivo_taller}
          placeholder="Ejemplo: Desarrollar habilidades de los docentes para implementar actividades de aprendizaje colaborativo en el aula"
          onChange={handleObjetivoTaller}
          InputProps={{
            sx: {
                borderRadius:2,
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem',
                color: '#005559',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default ObjetivoTaller;
